// @ts-strict-ignore
import { getAxiosInstance } from '@/requests/axios.utilities';
import { APPSERVER_API_PREFIX } from '@/main/app.constants';
import { getHref } from '@/utilities/utilities';

export function getItemForTool(item) {
  return getAxiosInstance().get(APPSERVER_API_PREFIX + getHref(item));
}
